import {baseLocalConfig} from '../base/local.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cnetLocalConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseLocalConfig, {
  environmentName: "Cnet Local Environment",
  ionicEnvName: 'local',
  loginFormLogo: './assets/logos/cnet-logo.png',
  loginLogoClass: 'cnetLogo',
  loginPageClass: 'cnetLoginPageBackground',
  logoColor: 'red',
  requiredFields: {
    content_article: {
      publish: [
        'dek',
        'primaryAuthor',
        'body',
        'primaryTopic',
        'articlePage',
      ],
      schedule: [
        'dek',
        'primaryAuthor',
        'body',
        'primaryTopic',
        'articlePage',
      ],
      preview: [
        'primaryTopic',
        'articlePage',
      ],
    },
  },
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cnet/local.config.ts